<template>
  <div id="question-page">
    <b-form>
      <b-tabs>
        <b-tab
          :title="'Information'"
          :title-link-class="['font-medium-5']"
          lazy
        >
          <information
            :formData="formData"
            @onUploadBanner="onUploadBanner"
            @onUploadDisplay="onUploadDisplay"
          />
        </b-tab>
        <b-tab
          :title="'Question'"
          :title-link-class="['font-medium-5']"
          :disabled="validFormDisable"
          lazy
        >
          <question
            :formData="formData"
            :formQuestion="formQuestion.payload"
            :optionQuestion="optionQuestion"
            :isEditForm="isEdit"
            @onAddSection="onAddSection"
            @onAddQuestion="onAddQuestion"
            @onAddChoice="onAddChoice"
            @onAddOther="onAddOther"
            @onRemoveChoice="onRemoveChoice"
            @onUploadImage="onUploadImage"
            @onUploadImageChoice="onUploadImageChoice"
            @onDuplicateSection="onDuplicateSection"
            @onDuplicateQuestion="onDuplicateQuestion"
            @onMergeSection="onMergeSection"
            @deleteQuestion="deleteQuestion"
            @deleteSection="deleteSection"
            @EditQuestion="EditQuestion"
            @onSaveReoder="onSaveReoder"
          />
        </b-tab>
      </b-tabs>
    </b-form>
  </div>
</template>

<script>
import Information from "./Tabs/Information.vue";
import Question from "./Tabs/Question.vue";
import useQuestionTab from "../hooks/useQuestionTab.js";

export default {
  props: {
    isEdit: { type: Boolean, default: false },
    formQuestionData: { type: Array, default: [] },
    surveyGroupId: { type: Number, default: null },
    surveyAction: { type: Object, default: null },
  },
  components: { Question, Information },
  setup(props) {
    const {
      formData,
      formQuestion,
      optionQuestion,
      onAddSection,
      onAddQuestion,
      onAddChoice,
      onAddOther,
      onRemoveChoice,
      onUploadImage,
      onUploadImageChoice,
      onDuplicateSection,
      onDuplicateQuestion,
      onMergeSection,
      onUploadBanner,
      onUploadDisplay,
      deleteQuestion,
      deleteSection,
      validFormDisable,
      EditQuestion,
      onSaveReoder,
    } = useQuestionTab(props);

    return {
      formData,
      formQuestion,
      optionQuestion,
      onAddSection,
      onAddQuestion,
      onAddChoice,
      onAddOther,
      onRemoveChoice,
      onUploadImage,
      onUploadImageChoice,
      onDuplicateSection,
      onDuplicateQuestion,
      onMergeSection,
      onUploadBanner,
      onUploadDisplay,
      deleteQuestion,
      deleteSection,
      validFormDisable,
      EditQuestion,
      onSaveReoder,
    };
  },
};
</script>

<style>
@import "~@/assets/css/pages/survey/question.css";
</style>

<style lang="scss" scoped>
#question-page ::v-deep {
  .nav-tabs .nav-link.disabled {
    color: #e7e7e7 !important;
  }
}
</style>